import React from 'react';
import Header from './components/Header/Header';
import { BrowserRouter,Routes,Route } from 'react-router-dom';
import Home from './pages/Home';
import Contato from './pages/Contato';
import Artigo from './pages/Artigo';
import NotFound from './pages/NotFound';
import StateCount from './estados/StateCount';
import StateApi from './estados/StateApi';
import PostsPages from './pages/PostsPage';
import PostDetails from './components/PostDetails/PostDetails';
import TechNews from './pages/TechNewsClient';
import {LanguageProvider} from "./Context/LanguageContext"


function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
        <Header/>
        
        <Routes>
          <Route path='/' element={<Home/>}/>
          <Route path='/posts' element={<PostsPages/>}/>
          <Route path='/contato' element={<Contato
            name="João Pedro Kriger" 
            email="jpsk145@gmail.com" 
            phone="+55 51 99549-2424" 
            address="Porto Alegre, Brazil" 
            photo="https://avatars.githubusercontent.com/u/128426379?v=4" 
          />}/>
          {/* <Route path='/artigo' element={<Artigo/>}/>
          <Route path='/count' element={<StateCount/>}/> */}
          <Route path='/effect' element={<StateApi/>}/>
          <Route path="/post/:id" element={<PostDetails />} />
          <Route path='news' element={<TechNews/>} />
          <Route path='/*' element={<NotFound/>}/>

        </Routes>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}



export default App;
